import type {
  CardConfig,
  NestGroupConfig,
  NestGroups,
  RowData,
} from "../nesting-summary-cards";

export class NestingCardsViewState {
  cols = 3;
  cardConfigs: CardConfig[] = [];
  showMoveSkuPopup = false;
  selectedCardConfig: CardConfig | null = null;
  tempSelectedCardConfig: CardConfig | null = null;
  tempCardConfigs: CardConfig[] = [];
  activeNestGroup: NestGroups | null = null;
  popupActiveNestGroup: NestGroups | null = null;
  isDragging = false;
  allTempChanges: Map<number, RowData[]> = new Map();
  originalStateBeforePopup: Map<number, RowData[]> = new Map();
  newNestGroupMapping: Map<number, string> = new Map();
  filterData: any = {
    brand: [] as string[],
    segment: [] as string[],
    pack_type: [] as string[],
    pack_size: [] as number[],
    pack_qty: [] as number[],
  };
  filters: Record<
    string,
    {
      selected: (string | number)[];
      search: string;
      values: (string | number)[];
    }
  > = {
    brand: { selected: [], search: "", values: [] },
    segment: { selected: [], search: "", values: [] },
    packType: { selected: [], search: "", values: [] },
    packSize: { selected: [], search: "", values: [] },
    packQty: { selected: [], search: "", values: [] },
    skuCount: { selected: [], search: "", values: [] },
  };
  filterConfigs = [
    { key: "brand", label: "Brand" },
    { key: "segment", label: "Segment" },
    { key: "packType", label: "Pack Type" },
    { key: "packSize", label: "Pack Size" },
    { key: "packQty", label: "Pack Quantity" },
    { key: "skuCount", label: "Nest Size" },
  ] as const;
  showAccordion = false;
  activeAccordionIndex: number[] = [];
  totalCardConfigs: CardConfig[] = [];
  pageSizes: number[] = [6, 12, 18, 24];
  pageSize: number = 6;
  currentPage: number = 1;
  totalItems: number = 0;
  appliedFiltersState: Record<string, (string | number)[]> = {};
  originalNestGroupConfigsSnapshot: NestGroupConfig[] = [];
  showUnsavedChangesDialog: boolean = false;
  originalTotalNests: number = 0;
}
